export const contentTableConfig = {
  title: '热点强股',
  propList: [
    {
      prop: 'stockName',
      label: '股票名称',
      minWidth: '80',
      isFixed: true,
    },
    {
      prop: 'stockCode',
      label: '股票代码',
      minWidth: '60',
      isFixed: true
    },
    {
      prop: 'plateName',
      label: '板块名称',
      minWidth: '80',
    },
    {
      prop: 'stockTag',
      label: '概念名称',
      minWidth: '80',
    },
    {
      prop: 'logic',
      label: '逻辑',
      minWidth: '80',
    },
    {
      prop: 'rate',
      label: '涨跌幅',
      minWidth: '50',
      slotName: 'rate',
      sortable: true
    },
    {
      prop: 'updateTime',
      label: '更新时间',
      minWidth: '100',
    },
    { label: '操作', width: '180', slotName: 'handler', isFixed: 'right' }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/stock/dataImport'
}
